/* eslint-disable */
const i18n = {
  "ko-KO": {
    "error": {
      "billing": {
        "missing_field": "죄송하지만 귀하의 거래가 거부되었습니다. 아래에서 필수 필드를 입력해 주세요. 국가, 구/군/시 및 주소.",
        "stripe": {
          "generic_error": "오류! 시스템에서 현재 귀하의 요청을 처리할 수 없습니다. 나중에 다시 시도하거나 다른 결제 방법을 사용해 보세요. 문제가 지속되면 거래 은행에 문의하거나 다른 결제 방법을 시도해 보세요. 그래도 문제가 계속되면 Zoom에 <a href=\"https://support.zoom.us/hc/en-us/requests/new?ticket_form_id=360000983032\">요청을 제출</a>하여 지원을 요청하세요.",
          "authentication_required": "신용 카드 번호가 잘못되어 귀하의 구매를 처리할 수 없습니다. 신용 카드 정보를 업데이트하거나 다른 결제 방법을 시도해 보세요. 문제가 지속되면 거래 은행에 문의하시는 것이 좋습니다.",
          "approve_with_id": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "call_issuer": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_not_supported": "이 카드에서 허용되지 않는 거래 유형입니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_not_supported_invoice": "이 신용 카드에서는 이 거래 유형이 허용되지 않습니다.거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "card_velocity_exceeded": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_velocity_exceeded_invoice": "계정에 잔액이 부족하여 결제가 거부되었습니다. 거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "currency_not_supported": "카드에서 이 결제 통화를 지원하지 않아 결제가 거부되었습니다. 통화를 USD로 변경하고 다시 시도하거나 다른 카드를 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "do_not_honor": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "do_not_try_again": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "expired_card": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "expired_card_invoice": "신용 카드 번호가 잘못되어 귀하의 구매를 처리할 수 없습니다. <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요. 문제가 지속되면 거래 은행에 문의하시는 것이 좋습니다.",
          "fraudulent": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "generic_decline": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_number": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_cvc": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_pin": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_zip": "주소가 잘못되어 구매를 처리할 수 없습니다. 카드에 대해 입력한 주소가 은행에 등록된 주소와 일치하는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_zip_invoice": "주소가 잘못되어 구매를 처리할 수 없습니다. <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "insufficient_funds": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "insufficient_funds_invoice": "계정에 잔액이 부족하여 결제가 거부되었습니다. 거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "invalid_account": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_request": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_amount": "금액 또는 통화 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_cvc": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_expiry_year": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_expiry_month": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_number": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_pin": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "issuer_not_available": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "lost_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "lost_card_invoice": "신용 카드 관련 문제 때문에 이 요청을 처리할 수 없습니다. 거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "merchant_blacklist": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "new_account_information_available": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "no_action_taken": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "not_permitted": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "offline_pin_required": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "online_or_offline_pin_required": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "pickup_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "pickup_card_invoice": "신용 카드 관련 문제 때문에 이 요청을 처리할 수 없습니다. 거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "pin_try_exceeded": "이 카드로 유효하지 않은 번호를 사용하여 시도한 결제가 제한 횟수를 초과했습니다. 다른 결제 방법을 사용해 보세요.",
          "processing_error": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "reenter_transaction": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "restricted_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "revocation_of_all_authorizations": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "revocation_of_authorization": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "security_violation": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "service_not_allowed": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "stolen_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "stolen_card_invoice": "신용 카드 관련 문제 때문에 이 요청을 처리할 수 없습니다. 거래 은행에 문의하거나 <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 정보를 업데이트하세요.",
          "stop_payment_order": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "testmode_decline": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "transaction_not_allowed": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "transaction_not_allowed_inr": "귀하의 카드는 직불 카드이므로 정기 거래를 지원하지 않습니다. 이 구매를 결제하려면 신용 카드를 사용하세요.",
          "try_again_later": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_decline_rate_limit_exceeded": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "withdrawal_count_limit_exceeded": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요."
        },
        "adyen": {
          "error_1": "We are unable to process this request due to an issue with the payment method, please contact your bank or try a different payment method.",
          "error_2": "Your purchase could not be processed due to an invalid credit card number. Please update the credit card information or try a different payment method. If the issue persists, we recommend contacting your bank.",
          "error_3": "Payment is declined because the account has insufficient funds, please contact your bank or try a different payment method.",
          "error_4": "You have exceeded the amount of attempts to process payment for this card with an invalid number. Please try another payment method.",
          "error_5": "The system could not process your request at this time, please try again later or using another payment method. If the problem persists please contact your bank or try a different payment method.",
          "error_6": "You have exceeded the amount of attempts to process payment for this payment method. Please try another payment method.",
          "error_7": "Your purchase could not be processed due to an invalid address. Please update the payment information or choose another form of payment.",
          "currency_not_supported": "카드에서 이 결제 통화를 지원하지 않아 결제가 거부되었습니다. 통화를 USD로 변경하고 다시 시도하거나 다른 카드를 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_cvc": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_request": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "merchant_blacklist": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "do_not_try_again": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_zip": "주소가 잘못되어 구매를 처리할 수 없습니다. 카드에 대해 입력한 주소가 은행에 등록된 주소와 일치하는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "issuer_not_available": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "withdrawal_count_limit_exceeded": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "insufficient_funds": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "generic_decline": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "offline_pin_required": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "not_permitted": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "expired_card": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "online_or_offline_pin_required": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "pickup_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_pin": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "call_issuer": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_velocity_exceeded": "은행 계좌의 잔고가 부족하거나 신용카드의 한도를 초과하는 등 자금 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "card_not_supported": "이 카드에서 허용되지 않는 거래 유형입니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "lost_card": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_number": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_amount": "금액 또는 통화 문제로 인해 결제가 거부되었습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "incorrect_cvc": "카드 정보가 잘못되어 구매를 처리할 수 없습니다. 카드 번호, 만료 날짜 또는 보안 코드가 잘못되었을 수 있습니다. 카드 정보가 카드에 표시된 대로 정확하게 입력되었는지 확인한 다음 다시 시도하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "do_not_honor": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "approve_with_id": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "new_account_information_available": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "no_action_taken": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요.",
          "invalid_account": "카드에 알 수 없는 문제가 발생하여 이 결제를 처리할 수 없습니다. 다른 카드 또는 결제 방법을 사용하세요. 문제가 지속될 경우 은행에 문의하세요."
        }
      }
    },
    "billing": {
      "required": "필수 항목",
      "enter_full_address": "전체 주소를 입력하십시오.",
      "invalid": "유효하지 않음",
      "transaction_declined": "트랜잭션이 거부되었습니다.",
      "accept_terms_of_service": "서비스 약관에 동의해 주십시오.",
      "invalid_quantity": "잘못된 수량",
      "not_european_country": "결제 주소는 EU 주소여야 합니다. 다른 청구 방법을 사용하여 EU의 거주지를 확인해 주십시오.",
      "expirationDate": "만료일",
      "cvv": "CVV",
      "credit_card_number": "신용 카드 번호",
      "card_hold_name": "카드 소유자 이름",
      "enter_special_characters": "유효하지 않은 문자를 입력했습니다. 계속하려면 |, ~ 또는 ^ 등의 기호를 제거하세요.",
      "invalid_zip": "5\uC790\uB9AC \uBBF8\uAD6D \uC6B0\uD3B8 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "invalid_jp_zip": "우편번호는 숫자만 입력해야 합니다.",
      "invalid_in_zip": "6자리 인도 우편번호를 입력하세요.",
      "first_name": "\uC774\uB984",
      "last_name": "\uC131",
      "company_organization": "\uD68C\uC0AC/\uC870\uC9C1 \uC774\uB984",
      "email_address": "\uC774\uBA54\uC77C \uC8FC\uC18C",
      "place_order": "주문하기",
      "cancel": "\uCDE8\uC18C",
      "pay_method": {
        "save_pay_method": "결제 방법 저장",
        "verify_pay_method": "결제 방법 확인"
      },
      "payment": {
        "paypal": "PayPal",
        "credit": "신용 카드 또는 직불카드",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "credit_name": "\uC2E0\uC6A9 \uCE74\uB4DC",
        "change_payment": "결제 방법 변경",
        "apple_pay_desc": "Apple Pay 월렛에서 결제 방법을 선택하려면 아래 버튼을 클릭하세요. 구매를 완료하기 전에 주문을 검토할 수 있습니다.",
        "apple_pay_not_supported": "Apple Pay 결제 옵션은 Safari 브라우저를 실행하는 적격 Apple 기기에서만 지원됩니다.",
        "google_pay_desc": "Google Pay 월렛에서 결제 방법을 선택하려면 아래 버튼을 클릭하세요.",
        "google_pay_not_supported": "기기 또는 웹 브라우저에서 Google Pay 결제 옵션이 지원되지 않습니다.",
        "payment_title": "\uACB0\uC81C \uBC29\uBC95",
        "paypal_pending_desc": "청구 계약을 승인하기 위해 PayPal로 이동합니다. 팝업이 차단되지 않았는지 확인하세요. 지금은 요금이 청구되지 않습니다.",
        "p24": "Przelewy24",
        "p24_desc": "\uCCAD\uAD6C \uACC4\uC57D\uC744 \uC2B9\uC778\uD558\uAE30 \uC704\uD574 Przelewy24\uB85C \uC774\uB3D9\uD560 \uAC83\uC785\uB2C8\uB2E4. \uD31D\uC5C5\uC774 \uCC28\uB2E8\uB418\uC9C0 \uC54A\uC558\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694. <br>\uC774 \uACB0\uC81C \uBC29\uBC95\uC774 \uB4F1\uB85D\uB429\uB2C8\uB2E4.",
        "sofort": "Sofort",
        "sofort_desc": "\uCCAD\uAD6C \uACC4\uC57D\uC744 \uC2B9\uC778\uD558\uAE30 \uC704\uD574 SOFORT\uB85C \uC774\uB3D9\uD560 \uAC83\uC785\uB2C8\uB2E4. \uD31D\uC5C5\uC774 \uCC28\uB2E8\uB418\uC9C0 \uC54A\uC558\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694. <br>\uC774 \uACB0\uC81C \uBC29\uBC95\uC774 \uB4F1\uB85D\uB429\uB2C8\uB2E4.",
        "sofort_upgrade_message": "SOFORT/SEPA\uB294 \uC5C5\uADF8\uB808\uC774\uB4DC\uC5D0 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uACB0\uC81C \uBC29\uBC95\uC744 \uBCC0\uACBD\uD558\uB824\uBA74 \"\uD3B8\uC9D1\" \uB9C1\uD06C\uB97C \uD074\uB9AD\uD558\uC138\uC694.",
        "customer_balance": "\u632f\u8fbc",
        "customer_balance_desc": "\uCCAD\uAD6C \uACC4\uC57D\uC744 \uC2B9\uC778\uD558\uAE30 \uC704\uD574 Furikomi\uB85C \uC774\uB3D9\uD560 \uAC83\uC785\uB2C8\uB2E4. \uD31D\uC5C5\uC774 \uCC28\uB2E8\uB418\uC9C0 \uC54A\uC558\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694. <br>\uC774 \uACB0\uC81C \uBC29\uBC95\uC774 \uB4F1\uB85D\uB429\uB2C8\uB2E4.",
        "customer_balance_upgrade_message": "Furikomi는 업그레이드에 사용할 수 없습니다. 결제 방법을 변경하려면 \"편집\" 링크를 클릭하세요.",
        "ideal": "iDEAL",
        "ideal_desc": "\uCCAD\uAD6C \uACC4\uC57D\uC744 \uC2B9\uC778\uD558\uAE30 \uC704\uD574 iDEAL\uB85C \uC774\uB3D9\uD560 \uAC83\uC785\uB2C8\uB2E4. \uD31D\uC5C5\uC774 \uCC28\uB2E8\uB418\uC9C0 \uC54A\uC558\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694.<br/>\uC774 \uACB0\uC81C \uBC29\uBC95\uC774 \uB4F1\uB85D\uB429\uB2C8\uB2E4.",
        "ideal_upgrade_message": "iDEAL/SEPA\uB294 \uC5C5\uADF8\uB808\uC774\uB4DC\uC5D0 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uACB0\uC81C \uBC29\uBC95\uC744 \uBCC0\uACBD\uD558\uB824\uBA74 \"\uD3B8\uC9D1\" \uB9C1\uD06C\uB97C \uD074\uB9AD\uD558\uC138\uC694.",
        "us_bank_account": "\ubbf8\uad6d ACH \uc790\ub3d9 \uc774\uccb4",
        "us_bank_account_desc": "\uccad\uad6c \uacc4\uc57d\uc744 \uc2b9\uc778\ud558\uae30 \uc704\ud574 \uc740\ud589 \uacc4\uc88c \uc774\uccb4\ub85c \uc774\ub3d9\ud569\ub2c8\ub2e4. \ud31d\uc5c5\uc774 \ucc28\ub2e8\ub418\uc9c0 \uc54a\uc558\ub294\uc9c0 \ud655\uc778\ud574 \uc8fc\uc138\uc694.\uc774 \uacb0\uc81c \ubc29\ubc95\uc774 \ub4f1\ub85d\ub429\ub2c8\ub2e4. \ucc38",
        "us_bank_account_upgrade_message": "\uc5c5\uadf8\ub808\uc774\ub4dc \uc2dc ACH \uc740\ud589 \uc774\uccb4\ub97c \uc0ac\uc6a9\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4. \uacb0\uc81c \ubc29\ubc95\uc744 \ubcc0\uacbd\ud558\ub824\uba74 \"\ud3b8\uc9d1\" \ub9c1\ud06c\ub97c \ud074\ub9ad\ud574 \uc8fc\uc138\uc694.",
        "klarna": "후불 결제",
        "klarna_desc": "청구 계약을 승인하기 위해 Klarna로 이동합니다. 팝업이 차단되지 않았는지 확인하세요. 이 결제 방법이 등록됩니다.",
        "klarna_upgrade_message": "업그레이드에 Klarna Bank 은행 이체를 사용할 수 없습니다. 결제 방법을 변경하려면 \"편집\" 링크를 클릭하세요.",
        "klarna_monthly_upgrade_message": "Klarna는 연간 구독에만 사용할 수 있습니다. 연간 구독으로 변경하거나 다른 결제 방법을 사용하세요.",
        "klarna_payment_catgory": {
          "pay_in_installments": "할부",
          "pay_later": "나중에 결제",
          "pay_now": "지금 결제하기",
          "pay_with_financing": "금융"
        },
        "wise_plus_banktransfer": "Wise + 은행 송금",
        "trustly": "Trustly +",
        "wise_plus_trustly": "Wise + Trustly",
        "interac": "Interac +",
        "wise_plus_interac": "Wise + Interac",
        "payid": "PayID +",
        "wise_plus_payid": "Wise + PayID",
        "fpx": "FPX +",
        "wise_plus_fpx": "Wise + FPX",
        "poli": "POLI +",
        "wise_plus_poli": "Wise + POLI",
        "paynow": "PayNow +",
        "wise_plus_paynow": "Wise + PayNow",
        "bacs": "BACS +",
        "wise_plus_bacs": "Wise + BACS",
        "fps": "FPS +",
        "wise_plus_fps": "Wise + FPS",
        "openbanking": "오픈 뱅킹 +",
        "wise_plus_openbanking": "Wise + 오픈뱅킹",
        "wise_plus_boleto": "Wise + Boleto",
        "wise_plus_pix": "Wise + Pix",
        "wise": "Wise",
        "wise_upgrade_message": "Wise는 업그레이드에 사용할 수 없습니다. 결제 방법을 변경하려면 \"편집\" 링크를 클릭해 주세요.",
        "wise_desc": "청구 계약을 승인하기 위해 WISE로 이동하게 됩니다. 팝업이 차단되지 않았는지 확인하세요. 이는 등록된 결제 수단이 됩니다.<br><br><strong>참고:</strong> 요청된 계좌 변경사항은 은행 송금 기간에 따라 지연될 수 있습니다. 급한 경우 카드 결제를 선택해 주세요.",
        "pay_with": "결제 방법",
        "bill_same_as_contact": "이 결제 방법에 아래 주소를 사용합니다",
        "waiting_auth_pay_method_title": "결제 방법 승인",
        "waiting_auth_pay_method_desc": "이 페이지를 닫거나 뒤로 가기 버튼을 누르면 안 됩니다. 팝업 창으로 이동하여 인증을 완료하세요.",
        "waiting_updating_pay_method_title": "결제 방법 업데이트 중",
        "waiting_updating_pay_method_desc": "이 페이지를 닫지 마세요.",
        "waiting_check_title": "주문을 처리하는 중입니다. 잠시 기다려 주세요...",
        "waiting_check_desc": "뒤로 가거나 브라우저를 닫기 전에 확인 메시지가 표시될 때까지 기다려 주세요.",
        "update_pay_method_tips": "결제 방법 변경 사항을 업데이트하거나 취소하세요.",
        "ach": {
          "name": "ACH",
          "verify_failed": "결제 방법이 확인되지 않았습니다. <a href=\"/billing/payment\">청구 정보</a>로 이동하여 결제 방법을 업데이트하세요.",
          "verify_pending_error": "결제 방법이 확인 대기 중에 있으므로 이 결제를 완료할 수 없습니다. <a href=\"/billing/payment\">청구 정보</a>로 이동하여 확인을 완료한 후 다시 시도하세요."
        },
        "sepa": "SEPA",
        "others": "기타",
        "pay_with_international_card": "해외 구매에 사용 가능한 신용카드 또는 직불카드로 결제하세요. 신용카드 사용 가능 여부 및 수수료에 대해 은행에 확인하시기 바랍니다.",
        "apm_payment_error": "다른 결제 방법을 시도하세요.",
        "apm_flow_lost_message": "문제가 발생한 것으로 보입니다. {0}(으)로 결제를 완료하려면 다시 시도하세요."
      },
      "zip_postal": "\uC6B0\uD3B8 \uBC88\uD638",
      "city": "\uB3C4\uC2DC",
      "state": "\uC8FC",
      "select_state": "\uC8FC \uC120\uD0DD",
      "country_region": "\uAD6D\uAC00/\uC9C0\uC5ED",
      "company_organization_legal": "\uBC95\uC778\uBA85",
      "just_me": "\uB098\uB9CC",
      "pop_up_blocked": "\uD31D\uC5C5\uC774 \uCC28\uB2E8\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uD31D\uC5C5\uC744 \uD5C8\uC6A9\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2ED\uC2DC\uC624.",
      "unknown_error": "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958!",
      "not_vat_registered": "VAT \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC74C",
      "vat_checkbox_desc": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uC99D\uBA85\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC815\uBCF4 \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2C8\uB77C\uB294 \uAC83\uC744 \uC99D\uBA85\uD568\uC5D0 \uC788\uC5B4 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0 EU \uBC95\uB839\uC5D0 \uB530\uB77C \uC801\uC6A9 \uAC00\uB2A5\uD55C \uC694\uAE08\uC73C\uB85C \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 VAT\uB97C \uBD80\uACFC\uD560 \uAC83\uC784\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "not_vat_tips": "\uB4F1\uB85D\uB41C EU \uBE44\uC988\uB2C8\uC2A4\uC758 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_SN_message": "VAT를 등록한 경우 납세 ID 번호를 입력하면 발행받은 청구서에 납세 ID 번호가 표시됩니다.",
      "vat_SN_placeholder": "납세 ID 번호",
      "vat_number": "VAT \uBC88\uD638",
      "amMsg": "VAT \uB4F1\uB85D \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624",
      "amMsgDesc": "\uC774 \uD655\uC778\uB780\uC744 \uC120\uD0DD\uD568\uC73C\uB85C\uC368 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC544\uB974\uBA54\uB2C8\uC544\uC5D0 VAT \uB4F1\uB85D\uC774 \uB418\uC5B4 \uC788\uB2E4\uB294 \uAC83\uC744 \uC778\uC815\uD569\uB2C8\uB2E4. \uBCF8\uC778\uC740 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C \uC9C4\uC220\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C, \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 \uC544\uB974\uBA54\uB2C8\uC544\uC5D0\uC11C VAT\uC5D0 \uB4F1\uB85D\uB418\uC5B4 \uC788\uC74C\uC744 \uC778\uC99D\uD560 \uB54C, \uBCF8\uC778\uC740 Zoom\uC774 \uC544\uB974\uBA54\uB2C8\uC544 VAT\uB97C \uCCAD\uAD6C\uD558\uC9C0 \uC54A\uC73C\uBA70, \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 VAT\uC5D0 \uB300\uD55C \uC790\uCCB4 \uD3C9\uAC00\uAC00 \uD544\uC694\uD560 \uC218 \uC788\uB2E4\uB294 \uAC83\uC744 \uBC1B\uC544\uB4E4\uC774\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "mdMsgDesc": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 \uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D(\uC608: \uBAB0\uB3C4\uBC14 \uC138\uAE08 \uBAA9\uC801\uC758 \uBC95\uC778)\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD569\uB2C8\uB2E4. \uBCF8\uC778\uC740 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C \uC138\uBB34 \uC0C1\uD0DC \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 \uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D(\uC608: \uBAB0\uB3C4\uBC14 \uC138\uAE08 \uBAA9\uC801\uC758 \uBC95\uC778)\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4(\uD574\uB2F9\uB418\uB294 \uACBD\uC6B0).",
      "vat_registration_placeholder": "VAT \uB4F1\uB85D \uBC88\uD638",
      "registered_for_vat": "VAT \uB4F1\uB85D\uB428",
      "not_gst_tips_for_au": "호주 GST에 등록된 비즈니스라면 호주 사업자 번호(이하 \"ABN\")를 입력합니다. ABN을 제공함으로써 귀하는 호주 GST에 등록되어 있으며 호주에서 사업을 영위할 목적으로(개인 또는 국내 목적이 아닌) Zoom의 서비스를 구매하는 것임을 선언합니다.",
      "gst_number": "GST \uBC88\uD638",
      "not_gst_registered": "GST \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC74C",
      "gst_checkbox_desc": "\uD655\uC778\uB780 \uC791\uC131\uC744 \uC644\uB8CC\uD568\uC5D0 \uC788\uC5B4, \uBCF8\uC778/\uB2F9\uC0AC\uB294 \uC0C1\uAE30 \uBA85\uBA85\uB41C \uBE44\uC988\uB2C8\uC2A4\uAC00 GST \uB4F1\uB85D\uB41C \uBE44\uC988\uB2C8\uC2A4\uAC00 \uC544\uB2C8\uBA70, \uC774 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD55C \uBAA8\uB4E0 \uCC45\uC784\uC744 \uC9C0\uACE0 \uC788\uC74C\uC744 \uC99D\uBA85\uD569\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C GST \uB4F1\uB85D \uC815\uBCF4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uAE30 \uBA85\uBA85\uB41C \uBE44\uC988\uB2C8\uC2A4\uAC00 GST \uB4F1\uB85D\uB41C \uBE44\uC988\uB2C8\uC2A4\uAC00 \uC544\uB2C8\uB77C\uB294 \uAC83\uC744 \uC99D\uBA85\uD568\uC5D0 \uC788\uC5B4, \uB098/\uC6B0\uB9AC\uB294 Zoom\uC774 EU \uBC95\uB960\uC5D0 \uB530\uB77C \uC801\uC6A9 \uAC00\uB2A5\uD55C \uC694\uAE08\uC73C\uB85C \uBAA8\uB4E0 \uACFC\uC138 \uAC00\uB2A5\uD55C \uC11C\uBE44\uC2A4\uC5D0 GST\uB97C \uBD80\uACFC\uD560 \uAC83\uC784\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "vat_header_val_BS": "\uBC14\uD558\uB9C8\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 TIN\uC744 \uC785\uB825\uD558\uBA74 \uBC1C\uD589 \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
      "vat_header_val_BH": "\uBC14\uB808\uC778\uC5D0 VAT \uB4F1\uB85D\uB41C \uC0AC\uC5C5\uC790\uC758 \uACBD\uC6B0 VAT ID \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
      "vat_id_number_placeholder": "VAT ID \uBC88\uD638",
      "vat_checkout_popup_message_IS_BH": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uC18C\uBE44\uC790, \uAE30\uC5C5 \uB610\uB294 \uC815\uBD80 \uAE30\uAD00\uC774 \uC138\uBB34 \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C \uC138\uBB34 \uC0C1\uD0DC \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uC18C\uBE44\uC790, \uAE30\uC5C5 \uB610\uB294 \uC815\uBD80 \uAE30\uAD00\uC774 \uC138\uAE08 \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4(\uD574\uB2F9\uB418\uB294 \uACBD\uC6B0).",
      "vat_header_val_BD": "VAT\uAC00 \uB4F1\uB85D\uB41C \uACBD\uC6B0 BIN \uC785\uB825",
      "vat_checkout_popup_message_BD": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC0AC\uC2E4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "vat_header_val_BB": "\uBC14\uBCA0\uC774\uB3C4\uC2A4\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uBA74 \uBC1C\uD589 \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
      "tin_number": "TIN \uBC88\uD638",
      "vat_header_val_KHM": "\uCE84\uBCF4\uB514\uC544\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 \uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message_KHM": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC0AC\uC2E4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "vat_header_val_CM": "비즈니스 고객인 경우 NIU를 입력하면 발행받은 청구서에 NIU가 표시됩니다",
      "tax_promote_cl": "\uC138\uAE08 ID \uBC88\uD638(RUT)\uB97C \uC785\uB825\uD558\uACE0 \uC18C\uC218\uC640 \uD558\uC774\uD508\uC740 \uBB34\uC2DC\uD558\uC2ED\uC2DC\uC624.",
      "rut_number": "RUT \uBC88\uD638",
      "vat_header_val_GE": "\uC870\uC9C0\uC544\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC0AC\uC2E4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C {0} VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "vat_checkout_popup_message_GE": "\uC870\uC9C0\uC544",
      "vat_header_val_GH": "\uAC00\uB098\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 \uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_header_val_IS": "\uC544\uC77C\uB79C\uB4DC\uC5D0 VAT \uB4F1\uB85D\uB41C \uC0AC\uC5C5\uC790\uC758 \uACBD\uC6B0 VAT ID \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
      "inMsg": "GST \uB4F1\uB85D\uB41C \uC0AC\uC5C5\uC790\uC778 \uACBD\uC6B0 GST \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694. \uC720\uD6A8\uD55C GSTIN\uC744 \uC81C\uACF5\uD558\uC9C0 \uC54A\uC73C\uBA74 \uC804\uC790 \uCCAD\uAD6C\uC11C\uAC00 \uBC1C\uD589\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. SEZ \uC0C1\uD0DC\uB294 \uC790\uB3D9\uC73C\uB85C \uD655\uC778\uB429\uB2C8\uB2E4.<br /><br />ZVC India\uB294 \uC778\uB3C4\uC758 GST \uB4F1\uB85D \uACE0\uAC1D\uC5D0\uAC8C \uC18C\uBAA8\uD488\uC5D0 \uB300\uD55C \uC804\uC790 \uCCAD\uAD6C\uC11C\uB97C \uBC1C\uD589\uD574\uC57C \uD569\uB2C8\uB2E4. \uC774\uB97C \uC218\uD589\uD558\uB824\uBA74 \uADC0\uD558\uC758 GST \uB4F1\uB85D \uBC88\uD638\uAC00 \uC9C0\uC815\uB41C \uC8FC/\uB3C4\uC640 \uCCAD\uAD6C\uC9C0 \uBC0F \uAD6C\uB9E4\uC790 \uC8FC\uC18C\uAC00 \uC18D\uD558\uB294 \uC8FC/\uB3C4\uAC00 \uBC18\uB4DC\uC2DC \uC77C\uCE58\uD574\uC57C \uD569\uB2C8\uB2E4.",
      "gst_checkbox_desc_template": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 GST \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uC99D\uBA85\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C GST \uB4F1\uB85D \uC815\uBCF4 \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 GST \uB4F1\uB85D\uC774 \uC544\uB2C8\uB77C\uB294 \uAC83\uC744 \uC99D\uBA85\uD568\uC5D0 \uC788\uC5B4 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0 {0}\uC5D0 \uB530\uB77C \uC801\uC6A9 \uAC00\uB2A5\uD55C \uC694\uAE08\uC73C\uB85C \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 GST\uB97C \uBD80\uACFC\uD560 \uAC83\uC784\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "tax_checkbox_desc_non_inr_in": "\uC778\uB3C4 \uBC95\uB839",
      "tax_promote_vat_cat1": "\uBD80\uAC00\uC138 \uB4F1\uB85D \uACE0\uAC1D\uC778 \uACBD\uC6B0 \uBD80\uAC00\uC138 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694. \uC774 \uBC88\uD638\uB294 Zoom\uC5D0\uC11C \uBC1C\uD589\uD55C \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
      "tax_number_on_invoice_tips": "Zoom\uC5D0\uC11C \uBC1C\uD589\uD55C \uCCAD\uAD6C\uC11C\uC5D0 \uACFC\uC138 \uBC88\uD638\uB97C \uD45C\uC2DC\uD558\uB824\uBA74 \uC5EC\uAE30\uC5D0 \uC138\uBD80 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC138\uC694.",
      "vat_header_val_KAZ": "\uCE74\uC790\uD750\uC2A4\uD0C4\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message_KAZ": "\uCE74\uC790\uD750\uC2A4\uD0C4",
      "keMsg": "\uAC1C\uC778 \uC2DD\uBCC4 \uBC88\uD638(PIN)\uB97C \uC785\uB825\uD558\uBA74 \uBC1C\uD589 \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
      "pin_number": "PIN \uBC88\uD638",
      "tax_promote_my": "\uC138\uC801 \uB4F1\uB85D \uACE0\uAC1D\uC778 \uACBD\uC6B0 \uACFC\uC138\uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694. \uC774 \uBC88\uD638\uB294 Zoom\uC5D0\uC11C \uBC1C\uD589\uD55C \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
      "tax_checkbox_md": "\uBE44\uC5C5\uBB34 \uACE0\uAC1D",
      "ngMsg": "\uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D\uC778 \uACBD\uC6B0 TIN(\uACFC\uC138 \uC2DD\uBCC4 \uBC88\uD638)\uC744 \uD3EC\uD568\uD558\uBA74 Zoom\uC5D0\uC11C \uBC1C\uAE09\uD55C \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
      "tax_promote_no": "'MVA' \uC55E\uC5D0 9\uC790\uB9AC \uC22B\uC790 VAT ID\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624",
      "mva_number": "MVA \uBC88\uD638",
      "tax_checkbox_desc_template": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uC99D\uBA85\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC815\uBCF4 \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2C8\uB77C\uB294 \uAC83\uC744 \uC99D\uBA85\uD568\uC5D0 \uC788\uC5B4 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0 {0}\uC5D0 \uB530\uB77C \uC801\uC6A9 \uAC00\uB2A5\uD55C \uC694\uAE08\uC73C\uB85C \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 VAT\uB97C \uBD80\uACFC\uD560 \uAC83\uC784\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "tax_checkbox_desc_no": "\uB178\uB974\uC6E8\uC774 \uBC95\uB839",
      "vat_header_val_OM": "\uC624\uB9CC\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message_OM": "\uC624\uB9CC",
      "vat_checkout_popup_message_RU": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC0AC\uC2E4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C \uB7EC\uC2DC\uC544 VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "tax_promote_default": "VAT \uB4F1\uB85D \uC0AC\uC5C5\uC790\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624",
      "vat_header_val_RS": "\uC138\uB974\uBE44\uC544\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uBA74 \uBC1C\uD589 \uCCAD\uAD6C\uC11C\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
      "not_gst_tips": "GST \uB4F1\uB85D\uB41C \uC0AC\uC5C5\uC790\uC778 \uACBD\uC6B0 GST \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
      "vat_header_val_TW": "\uB300\uB9CC\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message_TW": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC0AC\uC2E4\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2D8\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C \uB300\uB9CC VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "vat_header_val_TZ": "VAT\uB97C \uB4F1\uB85D\uD55C \uACBD\uC6B0 VRN(VAT \uB4F1\uB85D \uBC88\uD638)\uC744 \uC785\uB825\uD569\uB2C8\uB2E4",
      "tax_promote_tr": "VAT \uB4F1\uB85D\uB41C \uC0AC\uC5C5\uC790\uC758 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694",
      "tax_input_placeholder": "\uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638",
      "tax_checkbox_desc_tr": "\uD130\uD0A4 \uBC95\uB839",
      "ugMsg": "VAT\uAC00 \uB4F1\uB85D\uB41C \uACBD\uC6B0 TIN \uC785\uB825",
      "vat_header_val_UKR": "\uC6B0\uD06C\uB77C\uC774\uB098\uC5D0 \uB4F1\uB85D\uB41C VAT\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.",
      "vat_checkout_popup_message_UKR": "\uC6B0\uD06C\uB77C\uC774\uB098",
      "tax_checkbox_by": "\uBA74\uC138",
      "uzCheckboxMsg": "이 상자를 선택함으로써 본인은 비즈니스 고객(즉, 우즈베키스탄에 세금을 신고하는 법인)을 대리하며, 우즈베키스탄에 세금을 신고하는 개인 또는 개인 기업가가 아님을 인정합니다. 본인은 이 진술의 정확성과 완전성에 대해 전적으로 책임집니다. Zoom은 불완전하거나 부정확한 진술로 인한 어떠한 법적 책임도 지지 않습니다. 또한 본인이 비즈니스 고객을 대리하며 우즈베키스탄에 세금을 신고하는 개인 또는 개인 기업가가 아님을 확인함으로써 본인은 Zoom이 우즈베키스탄 VAT를 부과하지 않고 본인이 대리하는 비즈니스 고객이 납부할 VAT를 자진 신고해야 한다는 점을 인정하고 이해합니다.",
      "vat_header_val_VNM": "\uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D\uC778 \uACBD\uC6B0 \uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694. \uACE0\uAC1D\uC740 \uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC5EC \uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D\uC784\uC744 \uC120\uC5B8\uD558\uACE0, \uB530\uB77C\uC11C \uBCA0\uD2B8\uB0A8 \uC138\uBB34 \uB2F9\uAD6D\uC5D0 \uC138\uAE08\uC744 \uC2E0\uACE0\uD560 \uCC45\uC784\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
      "vat_checkout_popup_message_VNM": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 \uC138\uBB34 \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uBCF4\uC99D\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C \uC138\uBB34 \uC0C1\uD0DC \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uBCF8\uC778\uC774/\uC6B0\uB9AC\uAC00 \uC138\uBB34 \uB4F1\uB85D\uC774 \uB418\uC5B4 \uC788\uC9C0 \uC54A\uC74C\uC744 \uBCF4\uC99D\uD568\uC5D0 \uC788\uC5B4 \uBCF8\uC778\uC740/\uC6B0\uB9AC\uB294 \uC801\uC6A9 \uAC00\uB2A5\uD55C \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0\uB3C4 \uD574\uB2F9\uB418\uB294 \uC694\uAE08\uC73C\uB85C VAT\uB97C \uBD80\uACFC\uD568\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
      "tax_promote": {
        "include_your_vat_number": "VAT \uB4F1\uB85D \uACE0\uAC1D\uC778 \uACBD\uC6B0 VAT \uBC88\uD638\uB97C \uD3EC\uD568\uD558\uC138\uC694"
      },
      "tax_number_promote": {
        "default": "\uBE44\uC988\uB2C8\uC2A4 \uACE0\uAC1D\uC778 \uACBD\uC6B0 \uC138\uAE08 \uC2DD\uBCC4 \uBC88\uD638\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624"
      },
      "vat": {
        "GB_message": "비즈니스 고객인 경우, VAT 번호를 입력하세요.",
        "local_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to local legislation in addition to the prices listed in Order Summary.",
        "UK_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to UK legislation in addition to the prices listed in Order Summary.",
        "msg_by": "비즈니스 고객인 경우, 납세식별번호(TIN)를 입력하세요.",
        "checkbox_by": "비즈니스 외 고객",
        "tooltip_by": "이 확인란을 선택함으로써 본인/우리는 본인/우리가 벨라루스의 과세 대상이 되는 법인이 아니며 이 명세서의 정확성과 완전성에 대해 전적인 책임을 진다는 점을 확인합니다. Zoom은 불완전하거나 부정확한 명세서로 인한 어떠한 법적 책임도 지지 않습니다. 또한, 본인/우리가 벨라루스의 과세 대상이 되는 비즈니스 고객이 아님을 확인함으로써 본인/우리는 Zoom이 주문 요약에 나열된 가격 외에 해당 요율로 모든 과세 대상 서비스에 VAT를 부과한다는 점을 인정하고 이해합니다.",
        "msg_co": "VAT 등록을 한 경우, 납세식별번호(RUT)를 입력하세요.",
        "placeholder_co": "RUT",
        "tooltip_co": "확인란을 선택함으로써 본인/당사는 상기의 기업이 VAT 징수자('Responsable de IVA')가 아니며, 이 진술의 정확성과 완전성에 대해 전적인 책임을 진다는 점을 확인합니다. Zoom은 불완전하거나 부정확한 VAT 등록 공개로 인한 어떠한 법적 책임도 지지 않습니다. 또한, 상기의 기업이 VAT 징수자('Responsable de IVA')가 아님을 확인함으로써 본인/당사는 Zoom이 주문 요약에 나열된 가격 외에 모든 과세 대상 서비스에 해당하는 요율로 VAT를 부과한다는 점을 인정하고 이해합니다.",
        "tooltip_cl": "확인란을 선택함으로써 본인/우리는 상기의 비즈니스가 VAT 등록을 하지 않았으며 이 명세서의 정확성과 완전성에 대해 전적인 책임을 진다는 점을 확인합니다. Zoom은 불완전하거나 부정확한 VAT 등록 공개로 인한 어떠한 법적 책임도 지지 않습니다. 또한, 상기의 비즈니스가 VAT 등록을 하지 않았음을 확인함으로써 본인/우리는 Zoom이 주문 요약에 나열된 가격 외에 해당 요율로 모든 과세 대상 서비스에 VAT를 부과한다는 점을 인정하고 이해합니다.",
        "tooltip_eg": "확인란을 선택함으로써 본인/우리는 상기의 비즈니스/개인이 VAT 등록을 하지 않았으며 이 명세서의 정확성과 완전성에 대해 전적인 책임을 진다는 점을 확인합니다. Zoom은 불완전하거나 부정확한 VAT 등록 공개로 인한 어떠한 법적 책임도 지지 않습니다. 또한, 상기의 비즈니스/개인이 VAT 등록을 하지 않았음을 확인함으로써 본인/우리는 Zoom이 주문 요약에 나열된 가격 외에 해당 요율로 모든 과세 대상 서비스에 VAT를 부과한다는 점을 인정하고 이해합니다.",
        "msg_kr": "사업자등록번호 입력",
        "msg_th": "VAT 등록을 한 경우, VAT 번호를 입력하세요.",
        "tax_promote_eg": "VAT 등록을 한 경우, 납세등록번호를 입력하세요.",
        "tax_registration_number": "납세등록번호",
        "vat_cat2_checkbox_desc": "\uD655\uC778\uB780\uC744 \uC791\uC131\uD568\uC5D0 \uC788\uC5B4 \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uB418\uC9C0 \uC54A\uC558\uC74C\uC744 \uC99D\uBA85\uD558\uBA70 \uBCF8 \uC9C4\uC220\uC758 \uC815\uD655\uC131\uACFC \uC644\uC804\uC131\uC5D0 \uB300\uD574 \uC804\uC801\uC73C\uB85C \uCC45\uC784\uC9D1\uB2C8\uB2E4. Zoom\uC740 \uBD88\uC644\uC804\uD558\uAC70\uB098 \uBD80\uC815\uD655\uD55C VAT \uB4F1\uB85D \uC815\uBCF4 \uACF5\uAC1C\uB85C \uC778\uD55C \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C1\uC220\uD55C \uBE44\uC988\uB2C8\uC2A4\uAC00 VAT \uB4F1\uB85D\uC774 \uC544\uB2C8\uB77C\uB294 \uAC83\uC744 \uC99D\uBA85\uD568\uC5D0 \uC788\uC5B4 Zoom\uC774 \uC8FC\uBB38 \uC694\uC57D\uC5D0 \uB098\uC5F4\uB41C \uAC00\uACA9 \uC678\uC5D0 \uD604\uC9C0 \uBC95\uB839\uC5D0 \uB530\uB77C \uC801\uC6A9 \uAC00\uB2A5\uD55C \uC694\uAE08\uC73C\uB85C \uBAA8\uB4E0 \uACFC\uC138 \uB300\uC0C1 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD574 VAT\uB97C \uBD80\uACFC\uD560 \uAC83\uC784\uC744 \uC778\uC815\uD558\uACE0 \uC774\uD574\uD569\uB2C8\uB2E4.",
        "tax_requirement": {
          "desc": "본인은 사우디 세법을 준수하기 위해 사우디 고객은 세금이 원천징수되고 해당 금액이 관계 당국으로 송금되며 세금 원천징수의 적절성을 입증하기 위해 기록이 유지되며, Zoom에 관련 세금 원천징수 증명서를 제공해야 한다는 점을 인정합니다. 본인은 그러한 요건을 준수하지 않을 경우 사우디 법률에 따른 처벌을 받을 수 있다는 점을 잘 알고 있습니다.<br /><br />세금 원천징수 증명서는 다음으로 발송될 수 있습니다. <a href=\"mailto:{email}\">{email}</a>",
          "invalid_msg": "이 확인란 선택은 필수입니다"
        }
      },
      "export_control": {
        "biz_org_type": "\uBE44\uC988\uB2C8\uC2A4/\uC870\uC9C1 \uC720\uD615",
        "input_placeholder": "\uBE44\uC988\uB2C8\uC2A4/\uC870\uC9C1 \uC720\uD615 \uC785\uB825",
        "biz": "소매/도매",
        "fin": "\uC740\uD589 \uB610\uB294 \uAE08\uC735 \uAE30\uAD00",
        "edu": "유치원 및 초중고 학교",
        "med": "\uACF5\uC911 \uBCF4\uAC74 \uB610\uB294 \uC758\uB8CC \uAE30\uAD00",
        "util": "\uACF5\uACF5 \uC124\uBE44",
        "telcomm": "\uAD6D\uAC00 \uD1B5\uC2E0 \uD68C\uC0AC",
        "edu_high": "\uB300\uD559\uAD50/\uACE0\uB4F1 \uAD50\uC721",
        "sci_tech_inst": "\uACFC\uD559/\uAE30\uC220 \uC5F0\uAD6C\uC18C \uB610\uB294 \uAD6D\uAC00 \uB7A9",
        "gov": "\uAD6D\uAC00, \uC8FC \uB610\uB294 \uC9C0\uBC29 \uC815\uBD80 \uAE30\uAD00, \uAD00\uCCAD \uB610\uB294 \uBD80\uCC98",
        "other": "\uAE30\uD0C0",
        "adv": "광고",
        "mfg": "제조 및 산업",
        "ps": "전문 서비스 및 컨설팅",
        "bp": "생명 공학/제약",
        "cnstr": "건설",
        "ent": "엔터테인먼트",
        "lgl": "법률",
        "hpy": "숙박업",
        "np": "비영리",
        "tech": "기술",
        "trans": "운송",
        "re": "부동산"
      },
      "tax_exemption": {
        "ttr": {
          "link": "면세 상태 확인",
          "link_desc": "ECMS로 이동하고 면세 상태를 확인할 수 있도록 팝업이 차단되지 않도록 해 주세요.",
          "in_progress_title": "면세 확인 진행 중",
          "in_progress_desc": "파트너 웹사이트에서 면세 확인을 완료해 주세요. 세금 상태 확인이 완료되면 주문을 완료하기 위해 여기로 돌아오게 됩니다.<br/><br/>확인이 완료되기 전에 이 페이지에서 무언가를 변경하거나 창을 닫지 말아 주세요. 면세를 더 이상 진행할 필요가 없는 경우, 창을 닫고 주문을 계속하면 됩니다.",
          "in_progress_close_button": "닫기",
          "quit_progress_title": "진행하시겠습니까?",
          "quit_progress_desc": "면세 확인을 취소하고 과세 대상자로서 진행하시겠습니까?",
          "quit_progress_confirm": "예, 취소합니다",
          "quit_progress_cancel": "아니요, 계속 진행합니다",
          "status_incomplete": "확인이 완료되지 않았습니다. 면세를 받으려면 다시 클릭해 주세요.",
          "status_exempt": "면세",
          "status_pending": "대기 중",
          "status_retrieving": "검색 중...",
          "status_nonexempt": "비면세",
          "tax_status_label": "세금 상태: {0}",
          "status_pending_desc": "면세 상태를 현재 검토 중입니다. 이 주문에 따라 세금이 부과되며 검토가 승인되면 부과된 세금이 계정에 기록됩니다.",
          "status_retrieving_desc": "면세 상태를 검색 중입니다. 기다려 주세요."
        }
      },
      "video_sdk": {
        "use_case": "개발 사용 사례",
        "use_case_other": "기타(자세히 설명해 주세요)"
      },
      "usecase": {
        "gaming": "Gaming",
        "retail": "Retail",
        "social": "Social",
        "wellness": "Wellness",
        "e_learning": "온라인 학습",
        "telehealth": "원격 의료",
        "fintech": "핀테크",
        "legal": "법률",
        "hr_staffing": "HR/채용",
        "fitness": "피트니스",
        "events": "이벤트",
        "other": "기타"
      },
      "address": {
        "text": "\uC8FC\uC18C",
        "street_address": "도로 주소",
        "address_line2": "주소 라인 2",
        "phone": "\uC804\uD654\uBC88\uD638"
      },
      "addr": {
        "street_info": "도로 주소 정보는 적용될 수 있는 세금 및 수수료를 결정하기 위한 \"구매자\" 주소로 사용됩니다.",
        "line_2": "주소 라인 2",
        "biz_info": "비즈니스 주소입니다.",
        "doing_biz_as_name": "\uD68C\uC0AC\uBA85\uC73C\uB85C \uBE44\uC988\uB2C8\uC2A4 \uC218\uD589",
        "doing_biz_as_name_tips": "\uC18C\uC720\uC790\uC758 \uC774\uB984\uACFC \uB2E4\uB974\uAC70\uB098 \uD68C\uC0AC\uC758 \uBC95\uC778\uBA85\uACFC \uB2E4\uB978 \uC774\uB984\uC73C\uB85C \uBE44\uC988\uB2C8\uC2A4\uB97C \uC6B4\uC601\uD558\uB294 \uACBD\uC6B0\uC5D0 \uD574\uB2F9\uD569\uB2C8\uB2E4.",
        "business_size": "비즈니스 규모",
        "org_name": "조직 이름",
        "org_size": "조직 규모",
        "hq": "비즈니스 본사 국가/지역",
        "for_edu": {
          "tip": "학교용 계정이거나 18세 미만의 어린이가 있는 기타 조직을 위한 계정입니다.",
          "select_apply": "조직은 어떤 연령 그룹에 서비스를 제공합니까? (해당 항목을 모두 선택하십시오.)*",
          "under_13": "13세 미만",
          "range_n_m": "{0}~{1}세"
        }
      },
      "error": {
        "inr_non_india_error": "INR로 구매를 완료하려면 연락처 주소가 인도여야 합니다. 다른 국가를 선택하려면",
        "inr_non_india_error_switch_to_usd": "USD로 변경하세요",
        "empty_valid": "{0}은(는) 필수 항목입니다.",
        "required_field_not_completed": "필수 항목은 작성되지 않음",
        "common": {
          "bank_account_number": "은행 계좌번호"
        },
        "ach": {
          "bank_routing_number": "은행 ABA/라우팅 번호",
          "bank_account_type": "은행 계좌 유형",
          "bank_name": "은행명",
          "account_holder_name": "은행 계좌 소유자 이름"
        },
        "sepa": {
          "bank_account_name": "은행 계좌명",
          "street_number": "도로명 번호",
          "street_name": "도로명 이름",
          "account_email": "이메일",
          "account_country": "국가"
        }
      },
      "terms": {
        "india_emandate_desc": "<p><b>eMandate 계약</b><br>귀하는 귀하가 이용 중인 카드 발급사에 eMandate를 등록하기 위해 아래의 eMandate 세부 정보에 따라 귀하가 구매 중인 서비스의 구독료를 해당 카드에 청구할 수 있는 권한을 Zoom Video Communications에 부여합니다.<br><br>eMandate 시작일: {0}<br>eMandate 종료일: {1}<br>금액: 최대 ₹{2}(Zoom은 총 납부 금액의 범위 내에서만 청구합니다.)<br><br>이는 귀하가 선언문을 주의 깊게 읽고 이해했음을 확인하기 위한 것입니다. 귀하는 이 eMandate의 등록에 카드 발급사의 적법 절차에 따른 추가 인증 요소가 적용되며 귀하가 언제든지 이 eMandate를 철회, 열람 또는 수정할 수 있음을 이해합니다.</p>",
        "emandate_charge_process_table": {
          "table_desc": "정기 청구는 어떻게 처리되나요?",
          "threshold_header": "청구 금액",
          "threshold_1": "₹{0} 이하",
          "threshold_2": "₹{0} 초과",
          "action_header": "처리",
          "action_1": "청구 기간마다 아래의 eMandate 계약에 따라 AutoPay를 통해 결제를 처리합니다.",
          "action_2": "청구 기간마다 결제 기한이 되면 알려 드립니다. 매번 <a href=\"https://zoom.us/paynow\" target=\"_blank\">zoom.us/paynow</a>에서 직접 결제하셔야 합니다."
        },
        "pay_method_tokenization_disclaimer": "귀하는 당사가 공인한 제3자 토큰 서비스 공급자가 귀하의 카드 데이터를 토큰화하여 당사가 귀하가 선호하는 결제 방법을 저장하고 정기 청구에 사용할 수 있도록 하는 데 동의합니다.",
        "sepa_payment_terms": "귀하는 결제 정보를 제공하고 이 결제를 확인함으로써 (A) Zoom Video Communications Inc와 당사 결제 서비스 제공업체인 Stripe 및/또는 Stripe의 현지 서비스 제공업체인 PPRO가 귀하의 계좌에서 인출할 수 있도록 은행으로 지침을 전송하고 (B) 귀하의 은행에서 해당 지침에 따라 귀하의 계좌에서 인출하는 것을 승인합니다. 귀하는 권리의 일부로서 은행과의 계약 조건에 따라 은행으로부터 환불받을 권리가 있습니다. 환불은 귀하의 계좌에서 인출된 날부터 8주 이내에 청구해야 합니다. 귀하의 권리는 은행에서 받아보는 설명서에 나와 있습니다. 귀하는 향후 인출이 발생하기 최대 2일 전에 통보를 받는 데 동의합니다."
      }
    },
    "us": {
      "state_aa": "Armed Forces America",
      "state_ae": "Armed Forces",
      "state_ap": "Armed Forces Pacific",
      "state_al": "Alabama",
      "state_ak": "Alaska",
      "state_az": "Arizona",
      "state_ar": "Arkansas",
      "state_ca": "California",
      "state_co": "Colorado",
      "state_ct": "Connecticut",
      "state_wd": "Washington DC",
      "state_de": "Delaware",
      "state_fl": "Florida",
      "state_ga": "Georgia",
      "state_gu": "Guam",
      "state_hi": "Hawaii",
      "state_id": "Idaho",
      "state_il": "Illinois",
      "state_in": "Indiana",
      "state_ia": "Iowa",
      "state_ks": "Kansas",
      "state_ky": "Kentucky",
      "state_la": "Louisiana",
      "state_me": "Maine",
      "state_md": "Maryland",
      "state_ma": "Massachusetts",
      "state_mi": "Michigan",
      "state_mn": "Minnesota",
      "state_ms": "Mississippi",
      "state_mo": "Missouri",
      "state_mt": "Montana",
      "state_ne": "Nebraska",
      "state_nv": "Nevada",
      "state_nh": "New Hampshire",
      "state_nj": "New Jersey",
      "state_nm": "New Mexico",
      "state_ny": "New York",
      "state_nc": "North Carolina",
      "state_nd": "North Dakota",
      "state_oh": "Ohio",
      "state_ok": "Oklahoma",
      "state_or": "Oregon",
      "state_pa": "Pennsylvania",
      "state_pr": "Puerto Rico",
      "state_ri": "Rhode Island",
      "state_sc": "South Carolina",
      "state_sd": "South Dakota",
      "state_tn": "Tennessee",
      "state_tx": "Texas",
      "state_ut": "Utah",
      "state_vt": "Vermont",
      "state_va": "Virginia",
      "state_vi": "Virgin Islands",
      "state_wa": "Washington",
      "state_wv": "West Virginia",
      "state_wi": "Wisconsin",
      "state_wy": "Wyoming"
    },
    "ca": {
      "state_aa": "Alberta",
      "state_ba": "British Columbia",
      "state_ma": "Manitoba",
      "state_nd": "New Brunswick",
      "state_nr": "Newfoundland and Labrador",
      "state_ns": "Northwest Territories",
      "state_na": "Nova Scotia",
      "state_nt": "Nunavut",
      "state_oo": "Ontario",
      "state_pe": "Prince Edward Island",
      "state_qc": "Quebec",
      "state_sn": "Saskatchewan",
      "state_yn": "Yukon"
    },
    "inr": {
      "state_an": "Andaman and Nicobar",
      "state_ap": "Andhra Pradesh",
      "state_ar": "Arunachal Pradesh",
      "state_as": "Assam",
      "state_br": "Bihar",
      "state_ch": "Chandigarh",
      "state_cg": "Chhattisgarh",
      "state_dnh": "Dadra and Nagar Haveli",
      "state_dd": "Daman and Diu",
      "state_dl": "Delhi",
      "state_ga": "Goa",
      "state_gj": "Gujarat",
      "state_hr": "Haryana",
      "state_hp": "Himachal Pradesh",
      "state_jk": "Jammu and Kashmir",
      "state_jh": "Jharkhand",
      "state_ka": "Karnataka",
      "state_kl": "Kerala",
      "state_la": "Ladakh",
      "state_ld": "Lakshadweep",
      "state_mp": "Madhya Pradesh",
      "state_mh": "Maharashtra",
      "state_mn": "Manipur",
      "state_ml": "Meghalaya",
      "state_mz": "Mizoram",
      "state_nl": "Nagaland",
      "state_or": "Odisha",
      "state_ot": "Other Territory",
      "state_ph": "Puducherry",
      "state_pb": "Punjab",
      "state_rj": "Rajasthan",
      "state_sk": "Sikkim",
      "state_tn": "Tamil Nadu",
      "state_tg": "Telangana",
      "state_tr": "Tripura",
      "state_up": "Uttar Pradesh",
      "state_uk": "Uttarakhand",
      "state_wb": "West Bengal"
    },
    "country": {
      "AF": "Afghanistan",
      "AX": "Åland Islands",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "American Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarctica",
      "AG": "Antigua and Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Ascension Island",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia (Plurinational State of)",
      "BA": "Bosnia and Herzegovina",
      "BW": "Botswana",
      "BV": "Bouvet Island",
      "BR": "Brazil",
      "BQ": "Bonaire, Sint Eustatius and Saba",
      "IO": "British Indian Ocean Territory",
      "VG": "Virgin Islands (British)",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CA": "Canada",
      "IC": "Canary Islands",
      "CT": "Canton and Enderbury Islands",
      "CV": "Cabo Verde",
      "KY": "Cayman Islands",
      "CF": "Central African Republic",
      "EA": "Ceuta and Melilla",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CX": "Christmas Island",
      "CP": "Clipperton Island",
      "CC": "Cocos (Keeling) Islands",
      "CO": "Colombia",
      "KM": "Comoros",
      "CD": "Congo, Democratic Republic of the",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Côte d'Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Cyprus",
      "CZ": "Czechia",
      "DK": "Denmark",
      "DG": "Diego Garcia",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "NQ": "Dronning Maud Land",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "ET": "Ethiopia",
      "EU": "European Union",
      "FK": "Falkland Islands (Malvinas)",
      "FO": "Faroe Islands",
      "FJ": "Fiji",
      "FI": "Finland",
      "FR": "France",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "TF": "French Southern Territories",
      "FQ": "French Southern and Antarctic Territories",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germany",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Greece",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Heard Island and McDonald Islands",
      "HN": "Honduras",
      "HK": "Hong Kong SAR",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran (Islamic Republic of)",
      "IE": "Ireland",
      "IM": "Isle of Man",
      "IL": "Israel",
      "IQ": "Iraq",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Japan",
      "JE": "Jersey",
      "JT": "Johnston Island",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Korea (Democratic People's Republic of)",
      "KR": "Korea, Republic of",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Lao People's Democratic Republic",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macau SAR",
      "MK": "North Macedonia",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshall Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "FX": "Metropolitan France",
      "MX": "Mexico",
      "FM": "Micronesia (Federated States of)",
      "MI": "Midway Islands",
      "MD": "Moldova, Republic of",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Netherlands",
      "AN": "Netherlands Antilles",
      "NT": "Neutral Zone",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "VD": "North Vietnam",
      "MP": "Northern Mariana Islands",
      "NO": "Norway",
      "OM": "Oman",
      "QO": "Outlying Oceania",
      "PC": "Pacific Islands Trust Territory",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine, State of",
      "PA": "Panama",
      "PZ": "Panama Canal Zone",
      "PY": "Paraguay",
      "YD": "People's Democratic Republic of Yemen",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn",
      "PL": "Poland",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Romania",
      "RU": "Russian Federation",
      "RW": "Rwanda",
      "BL": "Saint Barthélemy",
      "SH": "Saint Helena, Ascension and Tristan da Cunha",
      "KN": "Saint Kitts and Nevis",
      "LC": "Saint Lucia",
      "MF": "Saint Martin (French part)",
      "PM": "Saint Pierre and Miquelon",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "CS": "Serbia and Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten (Dutch part)",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "GS": "South Georgia and the South Sandwich Islands",
      "ES": "Spain",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syrian Arab Republic",
      "TW": "Taiwan, China",
      "TJ": "Tajikistan",
      "TZ": "Tanzania, United Republic of",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad and Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UM": "United States Minor Outlying Islands",
      "PU": "U.S. Miscellaneous Pacific Islands",
      "VI": "Virgin Islands (U.S.)",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "GB": "United Kingdom",
      "US": "United States of America",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Holy See",
      "VE": "Venezuela (Bolivarian Republic of)",
      "VN": "Viet Nam",
      "WK": "Wake Island",
      "WF": "Wallis and Futuna",
      "EH": "Western Sahara",
      "YE": "Yemen",
      "ZM": "Zambia",
      "SD": "Sudan",
      "SS": "South Sudan",
      "ZW": "Zimbabwe",
      "CG": "Congo",
      "PG": "Papua New Guinea",
      "XG": "Global Mobile Satellite System",
      "XC": "ITPCS trials",
      "XT": "International Freephone",
      "XV": "International Networks",
      "XR": "International Premium Rate Service",
      "XS": "Shared Cost Services",
      "XD": "Telecommunications for Disaster Relief",
      "XP": "Universal Personal Telecommunications"
    }
  }
}
export default i18n
